import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Collapsible } from '@openx/components-core/lib/Collapsible/Collapsible';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledContainer } from '../../styledShared/StyledContainer';
import { StyledInfoIcon } from '../../styledShared/StyledInfoIcon';
import { UnforecastedTargetingSection } from './components/UnforecastedTargetingSection';

export const UnforecastedTargetingVariables = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer container data-test="unforecasted-targeting-variables-container">
      <Collapsible
        titleRender={
          <Typography variant="h3" data-test="unforecasted-targeting-variables-title">
            {t('Additional Impacts')}
            <Tooltip
              title={t(
                'The targeting variables below are not included in the forecast but will decrease the scale of your deal.'
              )}
              placement="top"
            >
              <StyledInfoIcon data-test="unforecasted-targeting-variables-title-tooltip" />
            </Tooltip>
          </Typography>
        }
      >
        <UnforecastedTargetingSection />
      </Collapsible>
    </StyledContainer>
  );
};
